<template>
  <div class="body" style="margin-top: 0.7rem">
    <div class="body_left">
      <div class="zs_">
        <img :src="imgzs" />
      </div>
      <div class="BL_list">
        <div :class="item.checked ? 'zs_list zs_listY' : 'zs_list zs_listN'" v-for="(item, index) in form.imgs"
          :key="index" @click="imgClick(item)">
          <img :src="item.img" />
        </div>
      </div>
    </div>
    <div class="body_right">
      <div class="BR_body">
        <p class="BR_body_title">
          {{ form.info?.name }}
          <!-- Canon/佳能EOS R6/R6 mark2 R6二代机身 全画幅专业微单相机
          8级防抖全画幅专业微单 -->
        </p>
        <p class="BR_body_pzsm">配置说明</p>
        <div class="BR_body_pzsmList">
          {{ form.info?.description }}
          <!-- <p>机身1个</p>
          <p>E6电池1个</p>
          <p>闪迪64g内存卡2个</p>
          <p>读卡器1个</p>
          <p>E6充电器1个</p>
          <p>便携包1个</p> -->
        </div>
      </div>
      <div class="BR_body_lsfs">
        <p class="BR_body_lsfs_title">联系方式</p>
        <p class="BR_body_lsfs_number">{{ form.info?.contactInformation }}</p>
      </div>
      <!-- <button class="BR_body_lsfs_button" v-if="show" @click="Contact()">
        联系
      </button> -->
    </div>
    <el-dialog v-model="PartnersMobileNumber" align-center width="480px" :close-on-click-modal="false">
      <div style="text-align: center">联系方式</div>
      <div style="text-align: center; padding-top: 5px; font-size: 20px">
        {{ PartnersMobileNumber1 }}
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="PartnersMobileNumber = false">
          取消
        </div>
        <div class="dataBtnSubmit" @click="PartnersMobileNumber = false">
          确认
        </div>
      </div>
    </el-dialog>
    <!-- 支付组件 -->
    <el-dialog title="" :show-close="false" v-model="payment" align-center width="4.8rem" :close-on-click-modal="false">
      <div class="zf_body">
        <div class="zf_body_top">
          <span>联系合作</span>
          <img @click="payment = false" class="cur" src="../../assets/module_share_open.png" />
        </div>
        <div class="zf_body_title">支付相应费用，获得联系方式</div>
        <div class="zf_b_M">
          <span CLASS="zf_b_M_title">应付金额：</span>
          <span class="zf_b_M_number"><text class="zf_b_M_n_icon">￥</text>9.90</span>
        </div>
        <div class="zf_fs_body">
          <div class="zf_fs_title">选择付款方式</div>
          <div class="zf_fs_list">
            <div v-for="index in paymentTypeList" :key="index" @click="paymentTL_click(index)">
              <img class="zf_fs_logo cur" :src="index.img" />
              <span>{{ index.title }}</span>
              <img v-if="index.checked" class="zf_fs_icon" src="../../assets/lxhz_icon.png" alt="" />
            </div>
          </div>
        </div>
        <div class="zf_fs_b">
          <div class="zf_fs_b_qx cur" @click="payment = false">取消</div>
          <div class="zf_fs_b_qd cur" @click="getMoney()">确定</div>
        </div>
      </div>
    </el-dialog>
    <two-dimensional-code ref="TwoDimensionalCodeRef" :CloseQrCode="CloseQrCode" />
  </div>
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { useRoute } from "vue-router";
import { ElMessage, ElTable, ElLoading } from "element-plus";
import TwoDimensionalCode from "@/views/ShadowComposer/components/TwoDimensionalCode.vue";
const router = useRoute();
const form = ref({});
document.title = "标识山西-找器材";
const imgzs = ref();
const PartnersMobileNumber = ref(false);
const PartnersMobileNumber1 = ref();
//支付金额
let moenyNumber = ref(0);
// 支付组件状态
let payment = ref(false);
let PaymentV = ref('');
let show = ref(true);
// 支付类型列表
let paymentTypeList = ref([
  // {
  //   title: "我的账户",
  //   img: require("../../assets/lxhz_pb.png"),
  //   checked: true,
  // },
  {
    title: "微信",
    dh: 'wx',
    img: require("../../assets/lxhz_wx.png"),
    checked: false,
  },
  {
    title: "支付宝",
    dh: 'zfb',
    img: require("../../assets/lxhz_zfb.png"),
    checked: false,
  },
]);
const TwoDimensionalCodeRef = ref<any>();
Axios(
  "get",
  `/material/material/equipment/${router.query.id}`,
  "",
  false,
  function (res) {
    if (res.data.code == 200) {
      // res.data.data.imgss = res.data.data.imgs.filter(
      //   (e) => e.isCoverSheet == 1
      // );
      form.value = res.data.data;
      // console.log(" res.data.data.info", res.data.data.info.createUserId);
      JSON.parse(localStorage.getItem("userList")).memberId ==
        res.data.data.info.createUserId
        ? (show.value = false)
        : (show.value = true);
      document.title += "-" + res.data.data.info.name;
      let list = res.data.data.imgs;
      let list2 = [];
      for (let i = 0; i < list.length; i++) {
        let index = {
          checked: "",
          img: "",
        };
        if (i == 0) {
          index.checked = true;
        } else {
          index.checked = false;
        }
        index.img = list[i].url;
        list2.push(index);
      }
      form.value.imgs = list2;
      // console.log(form.value)
      imgzs.value = form.value.imgs[0].img;
    } else {
      ElMessage.error(res.data.message);
    }
    console.log(form);
    console.log("==========");
  }
);
const imgClick = function (index) {
  imgzs.value = index.img;
  for (let i = 0; i < form.value.imgs.length; i++) {
    if (index == form.value.imgs[i]) {
      form.value.imgs[i].checked = true;
    } else {
      form.value.imgs[i].checked = false;
    }
  }
};
// 获取联系合作 // index 回去对象的的id
let Contact = function () {
  Axios(
    "get",
    "/material/material/equipmentOrder/isPay",
    { id: form.value.info.id },
    false,
    function (res) {
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.data;
    },
    function (res) {
      // ElMessage({
      //   showClose: true,
      //   message: res.data.msg,
      //   type: "warning",
      // });
      // console.log(res.data.data);
      // if(res.data.code !== 500){
      payment.value = true;
      // }
    }
  );
};
//获取金额
let getMoney = function () {
  let url: any;
  if (PaymentV.value == 'wx') {
    url = `/material/material/equipmentOrder/create-pay/WXPAY/${form.value.info.id}`
  } else if (PaymentV.value == 'zfb') {
    url = `/material/material/equipmentOrder/create-pay/ALIPAY/${form.value.info.id}`
  }
  Axios(
    "post",
    url,
    {},
    false,
    function (res) {
      // moenyNumber.value = res.data.msg;

      TwoDimensionalCodeRef.value.init(
        res.data.data.qrcode,
        res.data.data.sceneId,
        form.value.info.id
      );
    }
  );
};
// 支付获取联系方式
let get_sjh = function () {
  Axios(
    "POST",
    "/member/contacts?memberId=" +
    JSON.parse(localStorage.getItem("userList")).memberId,
    {},
    false,
    function (res) {
      console.log(res.data);
    },
    function (res) {
      Axios(
        "POST",
        `/member/contacts/create-order/${JSON.parse(localStorage.getItem("userList")).memberId
        }`,
        {},
        false,
        function (res) {
          console.log();

          // console.log(res.data.data);
          TwoDimensionalCodeRef.value.init(
            res.data.data.qrcode,
            res.data.data.sceneId,
            JSON.parse(localStorage.getItem("userList")).memberId
          );
        },
        function (res) {
          console.log(res.data);
        }
      );
    }
  );
};
const CloseQrCode = (e) => {
  payment.value = false;
  Axios(
    "get",
    "/material/material/equipmentOrder/isPay",
    { id: form.value.info.id },
    false,
    function (res) {
      // res;
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.data;
      // PartnersMobileNumber1.value = res.data.data.info.partyBContactInfo;
    },
    function (res) { }
  );
};
// 支付类型切换
let paymentTL_click = function (index) {
  PaymentV.value = index.dh
  for (let i = 0; i < paymentTypeList.value.length; i++) {
    if (index == paymentTypeList.value[i]) {
      paymentTypeList.value[i].checked = true;
    } else {
      paymentTypeList.value[i].checked = false;
    }
  }
};
</script>

<style scoped>
.body {
  width: 10.8rem;
  margin: 0 auto;
  display: flex;
  padding-bottom: 0.27rem;
}

.body_left {
  width: 4.8rem;
  margin-right: 0.4rem;
}

.zs_ {
  aspect-ratio: 1 / 1;
  width: 100%;
  overflow: hidden;
  position: relative;
}

.zs_>img,
.zs_list>img {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.BL_list {
  width: 100%;
  margin-top: 0.2rem;
  display: flex;
  overflow-x: scroll;
}

.zs_list {
  width: 0.8rem;
  margin-right: 0.2rem;
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  margin-bottom: 0.24rem;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  position: relative;
}

.zs_listY {
  border: 0.01rem solid #e9e9e9;
}

.zs_listY {
  border: 0.01rem solid #C01A26;
}

.BR_body {
  padding-bottom: 0.24rem;
  margin-bottom: 0.24rem;
  border-bottom: 0.01rem solid #e5e6eb;
}

.body_right {
  flex-grow: 1;
}

.BR_body_title {
  font-size: 0.2rem;
  color: #333333;
  margin-bottom: 0.24rem;
}

.BR_body_pzsm {
  font-size: 0.16rem;
  color: #333333;
  line-height: 0.19rem;
  margin-bottom: 0.16rem;
  margin-top: 0.24rem;
}

.BR_body_pzsmList>p {
  font-size: 0.16rem;
  color: #333333;
  line-height: 0.32rem;
}

.BR_body_lsfs {
  color: #333333;
  font-size: 0.16rem;
}

.BR_body_lsfs_title {
  margin-bottom: 0.16rem;
}

.BR_body_lsfs_button {
  margin-top: 0.6rem;
  background: #C01A26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  padding: 0.16rem 0.6rem;
  font-size: 0.14rem;
  color: #ffffff;
  border: 0rem solid #fff;
}

.zf_body {
  border-radius: 0.12rem;
}

.zf_body_top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}

.zf_body_top>span {
  color: #333333;
  font-size: 0.16rem;
}

.zf_body_top>img {
  width: 0.2rem;
}

.zf_body_title {
  color: #86909c;
  font-size: 0.14rem;
  text-align: center;
  margin-bottom: 0.12rem;
}

.zf_b_M {
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.zf_b_M_title {
  font-size: 0.14rem;
  color: #000000;
}

.zf_b_M_number {
  font-size: 0.24rem;
  color: #C01A26;
}

.zf_b_M_n_icon {
  font-size: 0.14rem;
}

.zf_fs_body {
  margin-top: 0.2rem;
}

.zf_fs_title {
  color: #000000;
  font-size: 0.14rem;
  margin-bottom: 0.12rem;
}

.zf_fs_list {
  display: flex;
}

.zf_fs_list>div {
  position: relative;
  border-radius: 0.04rem;
  border: 1px solid #e5e6eb;
  padding: 0.08rem 0.24rem;
  margin-right: 0.12rem;
  display: flex;
  align-items: center;
}

.zf_fs_logo {
  width: 0.24rem;
  margin-right: 0.04rem;
}

.zf_fs_icon {
  width: 0.25rem;
  position: absolute;
  right: 0;
  bottom: 0;
}

.zf_fs_b {
  display: flex;
  justify-content: center;
}

.zf_fs_b>div {
  padding: 0.08rem 0.3rem;
  font-size: 0.14rem;
  border-radius: 0.08rem;
  border: 0.01rem solid #333333;
}

.zf_fs_b_qx {
  color: #333333;
}

.zf_fs_b>.zf_fs_b_qd {
  color: #ffffff;
  border: 0.01rem solid #C01A26;
  background: #C01A26;
  margin-left: 0.2rem;
}

.zf_fs_body {
  margin-bottom: 0.2rem;
}

/deep/.el-dialog__header {
  padding: 0 !important;
}

.brt_list {
  display: flex;
}

.top_click_list>div {
  padding: 0.08rem 0.16rem;
  border-radius: 0.08rem;
  font-size: 0.14rem;
  margin-right: 0.2rem;
}

.top_click_listT {
  border: 0.01rem solid #C01A26;
}

.top_click_listF {
  border: 0.01rem solid rgba(0, 0, 0, 0);
}
</style>
